export default __webpack_public_path__ + "static/media/ic_card_travel.bbac99cb.svg";